export default "__VITE_ASSET__rCr$TohV__"